import { IconButton, Stack, Typography } from '@mui/material'
import { useMemo, useState } from 'react'
import { SvgAsset } from '~/components/SvgAsset'
import { getLanguageLocalStorage } from '~/features/i18n/utils/languageLocalStorage'
import * as GA from '~/libs/ga'
import { Colors } from '~/libs/mui/theme'
import { useOnClickLikeButton } from '../../VideoInfo/useOnClickLikeButton'

interface VideoLikeButtonDeprecatedProps {
  likeNum: number
  hasLike: boolean
  videoId: string
}

const useFormattedNumber = (number: number, lang: string): string => {
  return useMemo(() => {
    const formatter = new Intl.NumberFormat(lang, {
      notation: 'compact',
      compactDisplay: 'short',
    })
    return formatter.format(number)
  }, [lang, number])
}
/**
 * いつか検索用のGraphQLを作るまでの実装。
 * クエリができたら、VideoLikeButtonに統一する。
 * @deprecated　ここではいいねのステータスや数をuseStateで管理しています。
 */
export function VideoLikeButtonDeprecated({
  likeNum,
  hasLike,
  videoId,
}: VideoLikeButtonDeprecatedProps): JSX.Element {
  const onClickLikeButton = useOnClickLikeButton(videoId, hasLike, () => {
    GA.sendEvent({
      event: 'click',
      screen: 'stream',
      category: 'icon',
      action: 'stream_poster_like',
      label: `${videoId}`,
    })
  })
  const lang = getLanguageLocalStorage()
  const [likeCount, setLikeCount] = useState(likeNum)
  const [hasLikeState, setHasLikeState] = useState(hasLike)
  const formatLikeNum = useFormattedNumber(likeCount, lang ?? 'en')
  return (
    <Stack direction='row' spacing={0} alignItems='center' fontSize='12px'>
      <IconButton
        size='small'
        sx={{
          color: `${hasLikeState ? Colors.yellow : Colors.color5A5957}`,
          minHeight: 0,
        }}
        onClick={() => {
          onClickLikeButton()
          setLikeCount((prev) => (hasLikeState ? prev - 1 : prev + 1))
          setHasLikeState((prev) => !prev)
        }}
      >
        <SvgAsset asset='like' fontSize='small' />
      </IconButton>
      <Typography variant='caption' color='white'>
        {likeCount && formatLikeNum}
      </Typography>
    </Stack>
  )
}
